import React from 'react'
import { useTranslation } from "react-i18next"
import { LocalStorageService } from '../../../services'
import { ButtonHLPure, DialogSystemGLPure } from '..'
import './dialog-resend-signature-request.css'


const DialogResendSignatureRequest = (props) => {
    const { t } = useTranslation()

    let localStorageService = new LocalStorageService()
    const userSesionCurrent = localStorageService.getLocalStorageItem('user').userMetaData.userMifirma.email

    return (
        <>
            {(props?.signatureRequest?.signRequest?.signRequestStatus?.id === Number(process.env.REACT_APP_SIGN_REQUEST_STATUS_COMPLET) && props?.userCanResendInformation === true && props.signRequest.user.email === userSesionCurrent) ?
                <div>
                    {/* Button to display the dialog */}
                    <ButtonHLPure
                        nameBtn={t('dialogResendSignatureRequest.buttonResendInformation')}
                        onClickBtn={props.toggleDialogResendSignatureRequest}
                    />

                    {/* Dialog to resend the information */}
                    {props.visibleDialogResendSignatureRequest &&
                        <DialogSystemGLPure
                            showConfirm={true}
                            confirmTitle={t('dialogResendSignatureRequest.titleDialogResendSignatureRequest')}
                            confirmMessage={t('dialogResendSignatureRequest.labelDoYouWantToResendInformation')}
                            labelCancelConfirmation={t('button.close')}
                            labelSubmitConfirmation={t('dialogResendSignatureRequest.buttonSend')}
                            handleConfirmDeleteFlowClose={props.toggleDialogResendSignatureRequest}
                            handleConfirmDeleteFlowSubmit={props.onResendSignatureRequest}
                        />
                    }
                </div>
                : null}
        </>
    )
}

export { DialogResendSignatureRequest as default }